export default __webpack_public_path__ + "static/media/directions_car-24px.3ca97d2a.svg";